<template>
  <v-dialog
    v-model="open"
    max-width="790"
    width="530"
    persistent
    @keydown.prevent.enter="split"
  >
    <v-card class="dialog-box">
      <v-layout row justify-space-between class="home-floating-window-header">
        <v-layout row justify-start align-center>
          <v-card-title class="headline">
            {{ $t("SplitSelectedPathway.title") }}
          </v-card-title>
        </v-layout>
        <window-header-button @onClick="cancel" mode="dark" />
      </v-layout>
      <v-card-text>
        {{ $t("SplitSelectedPathway.initialMessage") }}

        {{ "- " + $t("SplitSelectedPathway.splitMessage") }}
        {{ "- " + $t("SplitSelectedPathway.snapMessage") }}
      </v-card-text>

      <v-card-actions>
        <v-btn @click="snap" :ripple="false" class="main-button" text>
          {{ $t("Snap") }}
        </v-btn>

        <v-btn @click="split" :ripple="false" class="main-button" text>
          {{ $t("Split") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import WindowHeaderButton from "@/components/_Atoms/WindowHeaderButton";
export default {
  name: "DialogTechPointSplitOrSnapPathway",
  components: { WindowHeaderButton },
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    /**
     * Send an event to the parent to execute the main action.
     */
    cancel() {
      this.$emit("cancel");
    },

    /**
     * Send an event to the parent to execute the main action.
     */
    snap() {
      this.$emit("snap");
    },
    /**
     * Send an event to the parent to execute the secondary action.
     */
    split() {
      this.$emit("split");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Dialog/DialogTechPointSplitOrSnapPathway.vue